import { render, staticRenderFns } from "./HeaderBurger.vue?vue&type=template&id=96334e7c&scoped=true&"
import script from "./HeaderBurger.vue?vue&type=script&lang=js&"
export * from "./HeaderBurger.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBurger.vue?vue&type=style&index=0&id=96334e7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96334e7c",
  null
  
)

export default component.exports